import AmplitudeEvent from './AmplitudeEvent'
import { getPageName } from './utils'

// =============================================================================
// Abstract base class for all social events
// =============================================================================

abstract class SocialAmplitudeEvent extends AmplitudeEvent {
  category = 'social'
}

// =============================================================================
// Social events (for descriptions, see the Notion doc)
// =============================================================================

export class ClickVideoCardEvent extends SocialAmplitudeEvent {
  name = 'click video card'

  constructor(path: string, videoId: string, creatorId: string) {
    super()
    this.properties = {
      page: getPageName(path),
      video: videoId,
      creator: creatorId,
    }
  }
}

export class ClickFeaturedVideoCardEvent extends SocialAmplitudeEvent {
  name = 'click featured video card'
}

export class ClickProfileEvent extends SocialAmplitudeEvent {
  name = 'click profile'
}

export class SwitchProfileTab extends SocialAmplitudeEvent {
  name = 'switch profile tab'

  constructor(from: string, to: string) {
    super({ from, to })
  }
}

export class FollowUserEvent extends SocialAmplitudeEvent {
  name = 'follow user'
}

export class UnfollowUserEvent extends SocialAmplitudeEvent {
  name = 'unfollow user'
}

export class TypeCommentEvent extends SocialAmplitudeEvent {
  name = 'type comment'
}

export class ClickLikeVideoEvent extends SocialAmplitudeEvent {
  name = 'click like video'
}

export class ClickAddToCalendarEvent extends SocialAmplitudeEvent {
  name = 'click add to calendar'
}

export class ClickFeaturedProfileEvent extends SocialAmplitudeEvent {
  name = 'click featured profile'
}

export class TypeReply extends SocialAmplitudeEvent {
  name = 'type reply'
}

export class ClickPostCommentEvent extends SocialAmplitudeEvent {
  name = 'click post comment'
}

export class ClickPostReplyEvent extends SocialAmplitudeEvent {
  name = 'click post reply'
}

export class ClickLikeCommentEvent extends SocialAmplitudeEvent {
  name = 'click like comment'
}

export class ClickLikeReplyEvent extends SocialAmplitudeEvent {
  name = 'click like reply'
}

export class EditProfileEvent extends SocialAmplitudeEvent {
  name = 'edit profile'
}
